import React, { forwardRef, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { useDropdownFilter } from '../Custom_Hooks/useDropdownFilter';
import { flushSync } from 'react-dom';
import { closeModal } from '../../redux/actions/action-creator';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { Link } from 'react-router-dom';

const DropdownNotApplicable = forwardRef(({ title, state, input_value, input_key, rawData, data, setData, setSubmitConfirm, inputRefs, handleDropdownClick }, ref) => {
    const dropdownRef = useRef(null)
    const dispatch = useDispatch();
    const { filteredData } = useDropdownFilter({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
    });

    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        inputRef: ref,
        onItemSelect: (item) => {

            flushSync(() => {
                const updatedData = {
                    ...data,
                    [input_key]: item?.name || item?.ledger_name || item?.symbol,
                };
                dispatch(closeModal(input_key))
                setData(updatedData);
            });
            if (handleDropdownClick) {
                handleDropdownClick(input_key, item?.name || item?.ledger_name || item?.symbol)
            }
        },
        input_value,
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
        <div className={`dropdown_dispatch_order ${state ? 'show-list' : ''}`}>
            <div className='col background' style={{ position: 'sticky', top: 0 }}>
                {title}
            </div>
            <div id='data'>
                {
                    Array.isArray(filteredData) && filteredData?.map((key, number) => {
                        const name = key?.name;
                        const index = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                        return (
                            <Link
                                className={`list font-weight-bold ${number === selectedItemIndex ? 'selected' : ''}`}
                                id='list'
                                key={number}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedItemIndex(number)
                                    if (number === selectedItemIndex) {
                                        flushSync(() => {
                                            const updatedData = {
                                                ...data,
                                                [input_key]: filteredData[number]?.name || filteredData[number]?.ledger_name || filteredData[number]?.symbol,
                                            };
                                            dispatch(closeModal(input_key))
                                            setData(updatedData);
                                            if (handleDropdownClick) {
                                                handleDropdownClick(input_key, name)
                                            }
                                        });
                                    }
                                }}
                            >
                                {index !== -1 ? (
                                    < >
                                        {name?.substring(0, index)}
                                        <span style={{ color: 'red' }}>{name?.substring(index, index + input_value.length)}</span>
                                        {name?.substring(index + input_value.length)}
                                    </>
                                ) : (
                                    name
                                )}
                            </Link>
                        );
                    })
                }
            </div>
        </div>
    )
}
)

export default DropdownNotApplicable
